import { GoogleAuthProvider, signInWithPopup, signOut, User } from "firebase/auth";
import { auth } from "./firebase";

/** A usable identity = a verified Google account with an email. Domain is NOT checked;
 *  access is decided entirely by the Firestore allowlist (see isAllowlisted / AuthContext). */
export function isVerified(user: User | null): boolean {
  return !!user?.email && user.emailVerified;
}

/** Google popup sign-in + a verified check only. Name kept for churn reasons. It NO LONGER
 *  gates the allowlist or signs a verified non-allowlisted user out — that state is now
 *  first-class `pending` (AuthContext routes it + joins the waitlist). Throws only on an
 *  unverified account or a popup failure. */
export async function signInCorp(): Promise<User> {
  const provider = new GoogleAuthProvider();
  const { user } = await signInWithPopup(auth, provider);
  if (!isVerified(user)) {
    await signOut(auth);
    throw new Error("A verified Google account is required.");
  }
  return user;
}
export const logout = () => signOut(auth);
